/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type mapSpacesWithParams$ref: FragmentReference;
declare export opaque type mapSpacesWithParams$fragmentType: mapSpacesWithParams$ref;
export type mapSpacesWithParams = {|
  +results: ?{|
    +spaces: ?$ReadOnlyArray<?{|
      +id: string,
      +searchMap: ?{|
        +location: ?$ReadOnlyArray<?number>,
        +slug: ?string,
        +place_id: ?string,
      |},
      +dataByCategory: ?{|
        +price: ?{|
          +amount_excl_tax: ?number
        |},
        +corpoPrice: ?{|
          +amount_excl_tax: ?number
        |},
      |},
    |}>,
    +byCity: ?$ReadOnlyArray<?{|
      +id: string,
      +location: ?$ReadOnlyArray<?number>,
      +spacesCount: ?number,
    |}>,
    +byDistrict: ?$ReadOnlyArray<?{|
      +id: string,
      +location: ?$ReadOnlyArray<?number>,
      +spacesCount: ?number,
    |}>,
  |},
  +$refType: mapSpacesWithParams$ref,
|};
export type mapSpacesWithParams$data = mapSpacesWithParams;
export type mapSpacesWithParams$key = {
  +$data?: mapSpacesWithParams$data,
  +$fragmentRefs: mapSpacesWithParams$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount_excl_tax",
    "storageKey": null
  }
],
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spacesCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "corpoRef"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "params"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "mapSpacesWithParams",
  "selections": [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Variable",
          "name": "params",
          "variableName": "params"
        }
      ],
      "concreteType": "SearchSpacesForMap",
      "kind": "LinkedField",
      "name": "searchSpaceByParams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchSpaceLocation",
              "kind": "LinkedField",
              "name": "searchMap",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "place_id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "category",
                  "value": "production"
                }
              ],
              "concreteType": "DataByCategory",
              "kind": "LinkedField",
              "name": "dataByCategory",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": "corpoPrice",
                  "args": [
                    {
                      "fields": [
                        {
                          "kind": "Variable",
                          "name": "corpoRef",
                          "variableName": "corpoRef"
                        }
                      ],
                      "kind": "ObjectValue",
                      "name": "input"
                    }
                  ],
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": "dataByCategory(category:\"production\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchLocation",
          "kind": "LinkedField",
          "name": "byCity",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchLocation",
          "kind": "LinkedField",
          "name": "byDistrict",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b12c02dbeda81208343c4cb1020a674c';

module.exports = node;
